<img [src]="imgUrl"
    (mouseenter)="onEnter($event)"
    (mouseleave)="onLeave($event)"
    (error)="onError($event)">